import { render } from "./App.vue?vue&type=template&id=1d0575dd&scoped=true&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=1d0575dd&scoped=true&lang=css"

import exportComponent from "/var/www/trovare/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d0575dd"]])

export default __exports__